import { NUMBER_OF_LOADING_PATIENTS } from '../constants/common'

export interface PatientDataRequest {
	text: string
	name: string
	email: string
	phone: string
	startOfService: string
	coachName: string
	account: string
	organization: string
	accountName: string
	status: string
	pmpmStatus: string
	gender: string
	state: string
	language: string
	location: string
	preferredTime: string
	plan: string
	diabetesType: string
	lastActivityFrom: number
	limit: number
}

export interface PatientDataResponse {
	text: string
	name: string
	email: string
	phone: string
	startOfService: string
	coachName: string
	account: string
	organization: string
	status: string
	pmpmStatus: string
	limit: number
}

export class PatientDataRequestModel implements PatientDataRequest {
	text: string
	name: string
	email: string
	phone: string
	startOfService: string
	coachName: string
	account: string
	organization: string
	accountName: string
	status: string
	pmpmStatus: string
	gender: string
	state: string
	language: string
	location: string
	preferredTime: string
	plan: string
	diabetesType: string
	lastActivityFrom: number
	limit: number
	coachId: string
	constructor() {
		this.text = ''
		this.name = ''
		this.email = ''
		this.phone = ''
		this.startOfService = ''
		this.coachName = ''
		this.account = ''
		this.organization = ''
		this.accountName = ''
		this.status = ''
		this.pmpmStatus = ''
		this.gender = ''
		this.state = ''
		this.language = ''
		this.location = ''
		this.preferredTime = ''
		this.plan = ''
		this.diabetesType = ''
		this.lastActivityFrom = 0
		this.limit = NUMBER_OF_LOADING_PATIENTS
		this.coachId = ''
	}
}
